export const TYPES = {
  CLIENT: 'client',
  SUBCONTRACTOR: 'subcontractor'
};
